// src/pages/roles/Roles.jsx
import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import RolesTable from "../../components/roles/RolesTable";

const Roles = () => (
    <WrapperSection>
        <GlobalBreadcrumbs />
        <RolesTable />
    </WrapperSection>
);

export default Roles;
